import React from 'react';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import SpaIcon from '@material-ui/icons/Spa';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { setGlobalLoadingSpinner } from '../../../../modules/GlobalUI';
import QuestionnaireButton from '../../../../components/molecule/Questionnaire/QuestionnaireButton';
import ProgramHistoryButton from '../../../../components/molecule/ProgramHistory/ProgramHistoryButton';
import dayjs from 'dayjs';
import DynamicTable from '../../../../components/molecule/Table';
import _ from 'lodash';
import { DonutGraph } from '../../../../components/molecule/Graph';
import { findUserChartById } from '../../../../services/apiServices';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '@material-ui/core/Icon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  min-width: 900px;
`
const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px 10px;
`;
const StretchContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
`;
const InputStyled = styled(Input)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`;
const TextFieldStyled = styled(TextField)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`;
const InfoContainer = styled(Paper)`
  display: flex;
  flex-direction: column;
  flex: 3;
  ${'' /* margin: 3px; */}
  margin-top: 10px;
  padding: 10px 15px;
  margin-bottom: auto;
`;
const HeaderContainer = styled.div`
  // background: rgba(0,0,0,0.1);
  margin: 10px 0;
`;
const FormStyled = styled(Form)`
  display: flex;
`;
const Header = styled.div`
  // background: rgba(0,0,0,0.1);
  font-size: 20px;
  font-weight: 600;
`;
const SectionHeading = styled.h2`
  margin-right: auto;
`;
const SectionHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

`;
const StyledLink = styled.a`
  text-decoration: none ;

  :hover {
    text-decoration: underline;
    transition: 1s;
  }
  
  input {
    cursor: pointer;
  }
`;
const QuestionnaireButtonStyled = styled(QuestionnaireButton)`
  margin: 10px 0px 0px 20px;
`;
const TasksSubHeading = styled.h5`
`;
const IconWrapper = styled.div`
`;
const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap:10px;
`;
const HeadingWrapper = styled.div`
`;
const Card = styled.div`
  width:inherit;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 10px;
  border-radius: 0.5rem;
`;
const Heading = styled.h3`
`;
const CardContainer = styled.div`
  display:flex;
  gap:10px;
  width:100%;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 13px;
`;
const FallbackText = styled.h3`
`;
const ProgramHistoryButtonStyled = styled(ProgramHistoryButton)`
    margin: 10px 0 0 auto;
`;
const DatePickerStyle = styled(DatePicker)`
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
  width: 100%;
`
const DatePickerWrapper = styled.div`
  position: relative;
  display: flex;
`;
const CalendarIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 17%;
  cursor: pointer;
`

class IndividualCoachForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedWeek: 'none',
      showData: false,
      selectedTrainer: "none",
      userProgress: null,
      cumulativeUserProgress: null,
      selectedDate: null,
      isCalendarOpen: false,
    }
   
  }


  changeTracker = (value, name) => {
    const { setFieldValue } = this.props;

    if (value === 'none') {
      setFieldValue(name, null, true);
    }
    else if (value === 'assigned') {
      this.setState({ showData: true });
      setFieldValue(name, value, true);
    }
    else if (value === 'new') {
      this.setState({ showData: false });
      setFieldValue(name, value, true);
    }
    else if (name === 'start_date') {
      const date = dayjs(value).format('YYYY-MM-DD');
      setFieldValue(name, date, true);
    }
    else {
      setFieldValue(name, value, true);
    }
    this.forceUpdate()
  }

  extractColumns = (data, columns) => {
    return data?.map(row =>
      columns?.reduce((obj, column) => {
        obj[column] = _.get(row, column);
        return obj;
      }, {})
    );
  };

  feedBackFinder = (value) => {
    let populatedKey;
    for (const val in value) {
      if (value[val].length) {
        populatedKey = value[val]
      }
    }
    return populatedKey
  }

  weekWiseFeedback = (allFeedbacks, selectedweek) => {
    const weekFeedback = allFeedbacks?.filter((value) => {
      return value.programset_order === selectedweek - 1
    })
    return weekFeedback
  }

  weekExtractor = (totalWeeks) => {
    let uniqueWeeks = totalWeeks?.map((value) => {
      return value.programset_order
    })
    let distinctWeeks = [...new Set(uniqueWeeks)]
    return distinctWeeks
  }

  componentDidMount() {
    const {
      values,
    } = this.props
    findUserChartById(values?.user?.id).then((value)=> this.setState({userProgress: value}))
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick = (e) => {
    if (!this.datePickerContainsClick(e) && !this.calendarIconContainsClick(e)) {
      this.setState({ isCalendarOpen: false });
    }
  }

  datePickerContainsClick = (e) => {
    return e.target.closest('.react-datepicker');
  }

  calendarIconContainsClick = (e) => {
    return e.target.closest('.calendar-icon');
  };

  handleDateChange = (date) => {
    const formattedDate = date.toLocaleDateString('en-US');
    if (date.getDay() === 1) {
    this.changeTracker(formattedDate, 'start_date');
    this.setState({
      selectedDate: date,
      isCalendarOpen: false
    });
    }
  };

  handleCalendarOpen = () => {
    this.setState(prevState => ({
      isCalendarOpen: !prevState.isCalendarOpen
    }));
  };

  handlePlaceHolder(programID) {
    const { wellnessProgramsData } = this.props
    const program = wellnessProgramsData.find((program) => program.id === programID)
    return program ? program.name : 'None'
  }

  render() {
    const {
      values,
      affiliatedTrainersData,
      wellnessProgramsData,
      initialValues
    } = this.props
    const { selectedWeek, userProgress } = this.state
    const extractedFeedback = this.feedBackFinder(values.Feedbacks)
    let reviewWeekvalues = this.weekExtractor(extractedFeedback)
    const selectedWeekFeedback = this.weekWiseFeedback(extractedFeedback, selectedWeek)
    const reviewColumnKeys = ['workout_name', 'results.comments', 'results.rating', 'results.questions'];
    const reviewColumnNames = ['Workout Name', 'Comment', 'Rating', 'Questions'];
    const dataWithReviewColumns = this.extractColumns(
      selectedWeekFeedback,
      reviewColumnKeys
    );
    let sortedProgramsData;
    let overallProgramsData = {}
    let physicalData = {}
    let wellnessData = {}
    if (userProgress) {
      sortedProgramsData = userProgress[0]?.content[0]?.data
      overallProgramsData = {
        "total": sortedProgramsData?.program.physical.total + sortedProgramsData?.program.wellness.total,
        "completed": sortedProgramsData?.program.physical.completed + sortedProgramsData?.program.wellness.completed
      }
      physicalData = {
        "total": sortedProgramsData?.program.physical.total,
        "completed": sortedProgramsData?.program.physical.completed

      }
      wellnessData ={
        "total": sortedProgramsData?.program.wellness.total,
        "completed":sortedProgramsData?.program.wellness.completed
      }
    }

    const unassignedProgram = wellnessProgramsData
      ?.filter((value) => value.assigned === false).find(value => value.id === values.program)

    return (
      <FormStyled>
        <Container>
          <Wrapper>
            <SectionHeadingContainer>
              <SectionHeading>Request Information</SectionHeading>
              <ProgramHistoryButtonStyled
                programHistory={values?.programs_history}
                header="Programs History"
                subheader="Program list the user is involved"
              />
              <QuestionnaireButtonStyled
                questionsAnswers={values?.questionnaire?.results?.questions}
                header="Questionnaire" 
                subheader="The questionnaire response from the client."
              />
            </SectionHeadingContainer>
            <StretchContainer>
              <InfoContainer>
                <HeaderContainer>
                  <Header>User Name</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  value={values.user?.username}
                  disabled
                />
                <HeaderContainer>
                  <Header>Email</Header>
                </HeaderContainer>
                <StyledLink href={`mailto:${values.user.email}`} target="_blank" rel="noopener noreferrer">
                  <InputStyled
                    type="email"
                    disableUnderline
                    fullWidth
                    value={values.user.email}
                    disabled
                  />
                </StyledLink>
                <HeaderContainer>
                  <Header>Days</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  value={values.days.map(day => day.name + " ")}
                  disabled
                />
                <HeaderContainer>
                  <Header>Request Date</Header>
                </HeaderContainer>
                <InputStyled
                  type="text"
                  disableUnderline
                  fullWidth
                  value={dayjs(values.created).format('ddd MMM D, YYYY h:mm a')}
                  disabled
                />
                <HeaderContainer>
                  <Header>Time</Header>
                </HeaderContainer>
                <Select
                  value={values.time.time_code}
                  inputProps={{ name: 'time', id: 'time', }}
                  disabled
                >
                  <MenuItem value={values.time.time_code}>{values.time.name}</MenuItem>
                </Select>
                <HeaderContainer>
                  <Header>Status</Header>
                </HeaderContainer>
                <Select
                  value={values.status}
                  onChange={(e) => { this.changeTracker(e.target.value, 'status') }}
                  inputProps={{ name: 'status', id: 'status', }}
                >
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="assigned">Assigned</MenuItem>
                </Select>
                <HeaderContainer>
                  <Header>Trainer</Header>
                </HeaderContainer>
                <Select
                  value={values.trainer ? values.trainer : 'none'}
                  onChange={(e) => this.changeTracker(e.target.value, 'trainer')}
                  inputProps={{ name: 'trainer', id: 'trainer', }}
                >
                  <MenuItem value='none'>None</MenuItem>
                  {
                    affiliatedTrainersData?.map((trainer, index) => {
                      return <MenuItem key={`trainer-${trainer.user_id}-${index}`} value={trainer.user_id}>{trainer.name}</MenuItem>
                    })
                  }
                </Select>
                <HeaderContainer>
                  <Header>Program</Header>
                </HeaderContainer>
                <Select
                  value={values.program ? values.program : 'none'}
                  onChange={(e) => this.changeTracker(e.target.value, 'program')}
                  inputProps={{ name: 'program', id: 'program', }}
                  renderValue={ unassignedProgram  ? null : () => this.handlePlaceHolder(values.program)}
                >
                  <MenuItem value='none' >None</MenuItem>
                  {
                    wellnessProgramsData
                      ?.filter((value) => value.assigned === false)
                      ?.map((program, index) => {
                        return <MenuItem key={`program-${program.id}-${index}`} value={program.id}>{program.name}</MenuItem>
                      })
                  }
                </Select>
                <HeaderContainer>
                  <Header>Start Date</Header>
                </HeaderContainer>
                <DatePickerWrapper>
                  <DatePickerStyle
                    selected={this.state.selectedDate}
                    onChange={this.handleDateChange}
                    filterDate={date => date.getDay() === 1}
                    dateFormat='yyyy-MM-dd'
                    todayButton='Today'
                    showIcon
                    open={this.state.isCalendarOpen}
                    placeholderText={values.start_date ? values.start_date : "yyyy-mm-dd"}
                  >
                  </DatePickerStyle>
                  <CalendarIcon className="calendar-icon" onClick={this.handleCalendarOpen}>
                    <Icon>today</Icon>
                  </CalendarIcon>
                </DatePickerWrapper>
                <HeaderContainer>
                  <Header>Notes</Header>
                </HeaderContainer>
                <TextFieldStyled
                  placeholder="Enter your notes here..."
                  multiline
                  onChange={(e) => this.changeTracker(e.target.value, 'notes')}
                  value={values.notes ?? ""}
                  rows={4}
                  inputProps={{ maxLength: 500 }}
                  helperText={`${values.notes?.length}/${500} characters remaining`}
                />
              </InfoContainer>
            </StretchContainer>
          </Wrapper>
          {((this.state.showData || initialValues.status === "assigned") && true) && (
            <>

              <Wrapper>
                <SectionHeading>Feedbacks</SectionHeading>
                <StretchContainer>
                  <InfoContainer>
                    <HeaderContainer>
                      <Header>Weeks</Header>
                    </HeaderContainer>
                    <Select
                      value={!reviewWeekvalues ? selectedWeek : selectedWeek}
                      onChange={(e) => this.setState({ selectedWeek: e.target.value })}
                      inputProps={{ name: 'value', id: 'value', }}
                    >
                      <MenuItem value='none'>None</MenuItem>
                      {reviewWeekvalues?.map((val, index) => {
                        return <MenuItem key={`program-${val.id}-${index}`} value={val + 1}>{`Week ${val + 1}`}</MenuItem>;
                      })}
                    </Select>
                    <HeaderContainer>
                      <Header>Feedback</Header>
                      <br />
                      {this.state.selectedWeek !== null && selectedWeek !== 'none' && (<>
                        <DynamicTable
                          data={dataWithReviewColumns}
                          columnKeys={reviewColumnKeys}
                          columnNames={reviewColumnNames}
                          items={extractedFeedback}
                          showQuestions={true}
                        />
                      </>)
                      }
                    </HeaderContainer>
                  </InfoContainer>
                </StretchContainer>
              </Wrapper>
            </>
          )}
          <Wrapper>

            <SectionHeading>Current Week Progress</SectionHeading>
            <StretchContainer>
              <InfoContainer style={{ width: "50px", display: "flex" }}>
                {userProgress?.length ? 
                  <CardContainer>
                    <Card>
                      <HeadingContainer>
                        <IconWrapper><SpaIcon /></IconWrapper><HeadingWrapper><Heading>Wellness</Heading></HeadingWrapper>
                        <TasksSubHeading>{`${wellnessData?.completed}/${wellnessData?.total} Completed`}</TasksSubHeading>
                      </HeadingContainer>
                      <DonutGraph dataset={sortedProgramsData?.program} datatype={"wellness"} />
                    </Card>
                    <Card>
                      <HeadingContainer>
                        <IconWrapper><FitnessCenterIcon /></IconWrapper><HeadingWrapper><Heading>Physical</Heading></HeadingWrapper>
                        <TasksSubHeading>{`${physicalData?.completed}/${physicalData?.total} Completed`}</TasksSubHeading>
                      </HeadingContainer>
                        <DonutGraph dataset={sortedProgramsData?.program} datatype={"physical"} />
                    </Card>
                    <Card >
                      <HeadingContainer>
                        <IconWrapper><DonutLargeIcon /></IconWrapper><HeadingWrapper><Heading>Overall Progress</Heading></HeadingWrapper>
                        <TasksSubHeading>{`${overallProgramsData?.completed}/${overallProgramsData?.total} Completed`}</TasksSubHeading>
                      </HeadingContainer>
                      <DonutGraph dataset={overallProgramsData} datatype={"completed"} />
                    </Card>
                  </CardContainer> : <FallbackText>No Data Available</FallbackText>}
              </InfoContainer>
            </StretchContainer>
          </Wrapper>
        </Container>
      </FormStyled>
    );
  }
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    name: yup.string(),
  }),

  validate: (values, props) => {
    props.submit(values);
  },

  displayName: 'IndividualCoachForm',
}))(IndividualCoachForm);